import React from "react";
import "./styles/flexbox.css";
import { FormattedMessage } from "react-intl";

function PlayBarButton(props) {
  // Render a button on the playbar with a click handler.
  // Optional classname, icon, and data-slide attribute.
  // If passed children: render those. Otherwise use an <i class="icon-X"> element.

  const classes = `btn f-g1${props.className ? " " + props.className : ""}`;
  return (
    <a className={classes} onClick={props.onClick} data-slide={props.slide}>
      {props.children ? props.children : <i className={`icon-${props.icon}`} />}
    </a>
  );
}

function PlayBar(props) {
  const buttons = [];
  if (props.previousFrame) {
    buttons.push(
      <PlayBarButton
        icon="chevron-left"
        onClick={props.previousFrame}
        slide="prev"
        key="previous"
      />
    );
  }

  if (props.nextFrame) {
    buttons.push(
      <PlayBarButton
        icon="chevron-right"
        onClick={props.nextFrame}
        slide="next"
        key="next"
      />
    );
  }

  if (props.liveMode) {
    buttons.push(
      <PlayBarButton
        onClick={props.liveMode.toggle}
        className={"btn-" + (props.liveMode.isEnabled ? "success" : "warning")}
        key="liveMode"
      >
        <FormattedMessage id="live" />
      </PlayBarButton>
    );
  }

  if (props.playback) {
    buttons.push(
      <PlayBarButton
        icon={props.playback.isEnabled ? "pause" : "play"}
        onClick={props.playback.toggle}
        key="playPause"
      />
    );
  }

  return <div className="btn-group d-flex f-around">{buttons}</div>;
}

export default PlayBar;
